import React from 'react';
import { useNavigate } from "react-router-dom";
import Plus from "assets/forum/plus.svg";
import Question from "assets/forum/question.svg";
import Saved from "assets/forum/bookmark.svg";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Typography,
  Grid
} from '@mui/material';

const ForumSidebar = ({ activeView, handleSidebarItemClick, slug }) => {
  const navigate = useNavigate();

  return (
<>
      <Box sx={{
        width: "100%",
        p: 3,
        overflowY: "auto",
        flex: 1,
        "& .list-container": {
          gap: 0,
        }
      }}>
        <Typography
          variant="h6"
          sx={{
            mb: 2,
            ml: 2,
            mt: 1,
            fontFamily: "Gilroy SemiBold",
            fontSize: "25px",
            fontWeight: 400,
            lineHeight: "50px",
            color: "rgba(36, 34, 34, 1)",
          }}
        >
          MTS Forum
        </Typography>

        <List sx={{ width: "100%", p: 0 }}>
          <ListItem
            button
            onClick={() => handleSidebarItemClick('all')}
            sx={{ mb: 0, px: 2, py: 1 }}>
            <Box
              component="img"
              src={Plus}
              alt="Home"
              sx={{ width: "25px", height: "25px", mr: 2 }}
            />
            <ListItemText
              primary={
                <Typography
                  sx={{
                    fontFamily: "Gilroy Medium",
                    fontSize: "18px",
                    color: activeView === 'all' ? 'rgba(57, 204, 204, 1)' : 'rgba(43, 61, 79, 1)'
                  }}
                >
                  Home
                </Typography>
              }
            />
          </ListItem>

          <ListItem
            button
            onClick={() => handleSidebarItemClick('user')}
            sx={{ mb: 0, px: 2, py: 1 }}>
            <Box
              component="img"
              src={Question}
              alt="Threads"
              sx={{ width: "25px", height: "25px", mr: 2 }}
            />
            <ListItemText
              primary={
                <Typography
                  sx={{
                    fontFamily: "Gilroy Medium",
                    fontSize: "18px",
                    color: activeView === 'user' ? 'rgba(57, 204, 204, 1)' : 'rgba(43, 61, 79, 1)'
                  }}
                >
                  Your Threads
                </Typography>
              }
            />
          </ListItem>

          <ListItem
            button
            onClick={() => handleSidebarItemClick('saved')}
            sx={{ mb: 0, px: 2, py: 1 }}>
            <Box
              component="img"
              src={Saved}
              alt="Saved"
              sx={{ width: "25px", height: "25px", mr: 2 }}
            />
            <ListItemText
              primary={
                <Typography
                  sx={{
                    fontFamily: "Gilroy Medium",
                    fontSize: "18px",
                    color: activeView === 'saved' ? 'rgba(57, 204, 204, 1)' : 'rgba(43, 61, 79, 1)'
                  }}
                >
                  Saved
                </Typography>
              }
            />
          </ListItem>
        </List>
      </Box>

      <Box sx={{ p: 7, whiteSpace: 'nowrap' }}>
        <ListItem
          button
          onClick={() => navigate(`/app/course/${slug}/learn`)}
        >
          <Typography
            sx={{
              fontFamily: "Gilroy Regular",
              fontSize: "16px",
              lineHeight: "25px",
              color: "rgba(43, 61, 79, 1)",
              ml: -9
            }}
          >
            {"<"} Back to Course Dashboard
          </Typography>
        </ListItem>
      </Box>
 </>
  );
};

export default ForumSidebar;